var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/* eslint-disable react/no-array-index-key */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldArray as Base } from 'formik';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import Button from './Button';
var FieldArray = function FieldArray(_ref) {
  var name = _ref.name,
    label = _ref.label,
    mutable = _ref.mutable,
    initialValue = _ref.initialValue,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ['name', 'label', 'mutable', 'initialValue', 'children']);
  return React.createElement(Base, _extends({
    name: name
  }, props), function (helpers) {
    return React.createElement(React.Fragment, null, helpers.form.values[name] && helpers.form.values[name].map(function (v, i) {
      return React.createElement(React.Fragment, {
        key: i
      }, mutable && React.createElement(Button, {
        size: 'sm',
        outline: true,
        color: 'danger',
        spear: true,
        type: 'button',
        onClick: function onClick() {
          return helpers.remove(i);
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: 'minus'
      }), React.createElement('span', {
        className: 'd-none d-md-inline ml-2'
      }, 'Remove ', capitalize(label || name))), children(_extends({}, helpers, {
        index: i
      })), i !== helpers.form.values[name].length - 1 && React.createElement('hr', null));
    }), mutable && React.createElement(Button, {
      size: 'sm',
      outline: true,
      color: 'tertiary',
      spear: true,
      type: 'button',
      onClick: function onClick() {
        return helpers.push(initialValue);
      }
    }, React.createElement(FontAwesomeIcon, {
      icon: 'plus'
    }), React.createElement('span', {
      className: 'd-none d-md-inline ml-2'
    }, 'Add ', capitalize(label || name))));
  });
};
FieldArray.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  mutable: PropTypes.bool,
  initialValue: PropTypes.string,
  children: PropTypes.node.isRequired
};
FieldArray.defaultProps = {
  label: undefined,
  mutable: true,
  initialValue: ''
};
export default FieldArray;